module.exports = __webpack_public_path__ + "img/search-icon.ff75c11b.svg";